/* eslint-disable @typescript-eslint/no-unused-vars */
import { Field } from '@vtblife/uikit/dist/legacy';
import React, { useMemo } from 'react';
import get from 'lodash/get';
import { Button, Group, Textarea } from '@vtblife/uikit';
import { createFormikComponent, mapFieldToInputProps } from '@vtblife/uikit-formik';
import { useFormikContext } from 'formik';
import styles from './formik-rating-field.module.css';
const FormikRatingFieldProps = function (props) {
    // Skip some of params to be passed by Field to Rating
    const { isValid, isError, errorMessage, fullWidth, label, note, hideNoteSpace, onChange, variant, name, commentForRating, maxRatingText, minRatingText, ...rest } = props;
    const { values, setFieldValue } = useFormikContext();
    const ratingValue = get(values, `${name}.rating`);
    const commentValue = get(values, `${name}.comment`) || '';
    const items = useMemo(() => {
        const [min, max] = variant.split('-');
        const items = [];
        for (let i = Number(min); i <= Number(max); i++) {
            const indexString = String(i);
            items.push(React.createElement(Button, { selected: indexString === ratingValue, variant: "secondary", onClick: (e) => {
                    setFieldValue(`${name}.rating`, indexString);
                }, key: indexString }, indexString));
        }
        return items;
    }, [variant, ratingValue, setFieldValue, name]);
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.rating },
            React.createElement(Group, { size: "l" }, items),
            React.createElement("div", { className: styles.ratingDescription },
                minRatingText && React.createElement("span", { className: styles.minRatingText }, minRatingText),
                maxRatingText && React.createElement("span", { className: styles.maxRatingText }, maxRatingText))),
        (commentForRating === null || commentForRating === void 0 ? void 0 : commentForRating.includes(ratingValue)) && (React.createElement("div", { className: styles.comment },
            React.createElement(Textarea, { rows: 4, onChange: (value) => {
                    const currentValue = value.toString();
                    setFieldValue(`${name}.comment`, currentValue);
                }, value: commentValue, size: "l", placeholder: "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439" })))));
};
export const RatingField = Field(FormikRatingFieldProps, false, false);
export const FormikRatingField = createFormikComponent(RatingField, mapFieldToInputProps);
//# sourceMappingURL=formik-rating-field.js.map